interface IDetailActionsProps {
  onAccept?: () => void;
  onReject?: () => void;
  hasCounterProposal?: boolean;
}

const DetailActions = (props: IDetailActionsProps) => {
  return (
    <div className="flex flex-row justify-between items-start mt-10">
      <div className="flex flex-row items-start gap-2 flex-1">
        <div className="flex bg-[#e7eff5] rounded-md flex-row items-center justify-center border border-[#4e7b99] p-2 flex-1">
          <img src="/assets/images/info.svg" alt="Info" className="w-8 h-8 mt-1 mr-2" />
          <div className="text-size-16 text-gray-600">
            Ao clicar em Aceitar, o serviço será autorizado e o veículo seguirá para manutenção.
          </div>
        </div>
      </div>

      <div className="flex flex-row gap-4">
        {
          props.hasCounterProposal ? (
            <>
              <button
                type="button"
                className="ml-5 w-[250px] bg-teal-500 text-white rounded-md hover:bg-teal-600 px-6 py-2 text-size-15 font-bold"
                onClick={props.onReject}
              >
                Enviar contraproposta
              </button>
            </>
          ) : (
            <>
              {props.onReject && (
                <button
                  type="button"
                  className="ml-6 w-[250px] border border-red-500 text-red-500 bg-white rounded-md hover:bg-red-50 px-6 py-2 text-size-15 font-bold"
                  onClick={props.onReject}
                >
                  Recusar
                </button>
              )}
              {props.onAccept && (
                <button
                  type="button"
                  className="ml-5 w-[250px] bg-teal-500 text-white rounded-md hover:bg-teal-600 px-6 py-2 text-size-15 font-bold"
                  onClick={props.onAccept}
                >
                  Aceitar
                </button>
              )}
            </>
          )
        }
      </div>
    </div>
  );
};

export default DetailActions;
